module.exports = __webpack_public_path__ + "media/svg/cw-40e4f500.svg";